import { Component, OnInit, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { AudioRecordingService } from './audio-recording.service';
import { DomSanitizer } from '@angular/platform-browser';
import { S3Service } from 'src/app/Portal/file-complain/s3.service';
import { ToastrService } from 'ngx-toastr';
import { FileComplainService } from 'src/app/Portal/file-complain/file-complain.service';
import { AuthService } from '../authentication/auth.service';
import { Observable, Subject } from 'rxjs';
import * as RecordRTC from 'recordrtc';
import * as moment from 'moment';
declare var $;
// import { AuthService } from '../authentication/auth.service';

@Component({
  selector: 'app-analytics',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class Home implements OnInit {

  heading = 'Analytics Dashboard';
  subheading = 'This is an example dashboard created using build-in elements and components.';
  icon = 'pe-7s-plane icon-gradient bg-tempting-azure';

  slideConfig6 = {
    className: 'center',
    infinite: true,
    slidesToShow: 1,
    speed: 500,
    adaptiveHeight: true,
    dots: true,
  };
  isRecording = false;
  recordedTime;
  blobUrl;
  error;
  blobForVoiceClip: Blob;
  urlOfUploadeVoice: any;
  noMediDeviceFound: string;
  disableUploadButton: boolean;
  constructor(
    private router: Router, private audioRecordingService: AudioRecordingService, private fileComplainService: FileComplainService,
    private sanitizer: DomSanitizer, private uploadService: S3Service, private toastr: ToastrService, public authService: AuthService
  ) {
    this.recordingFailed().subscribe(() => {
      this.isRecording = false;
    });

    this.getRecordedTime().subscribe((time) => {
      this.recordedTime = time;
    });

    this.getRecordedBlob().subscribe((data) => {
      this.blobForVoiceClip = data.blob;
      this.blobUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(data.blob));
    });
  }
  public datasets = [
    {
      label: 'My First dataset',
      data: [65, 59, 80, 81, 46, 55, 38, 59, 80],
      datalabels: {
        display: false,
      },

    }
  ];

  public datasets2 = [
    {
      label: 'My First dataset',
      data: [46, 55, 59, 80, 81, 38, 65, 59, 80],
      datalabels: {
        display: false,
      },

    }
  ];

  public stream;
  public recorder;
  public interval;
  public startTime;
  public _recordingFailed = new Subject<string>();
  public _recordingTime = new Subject<string>();
  public _recorded = new Subject<any>();


  sanitize(url: string) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }
  ngOnInit() {
  }
  ngOnDestroy() {
    this.abortRecording();
    $('.modal').modal('hide');
    $('.modal-backdrop').remove();
  }
  goToCases() {
    let logInToken = localStorage.getItem('access_token')
    if (logInToken) {
      this.router.navigateByUrl('/my-complains');
    } else {
      this.router.navigateByUrl('/login');
    }
  }

  getRecordedBlob(): Observable<any> {
    return this._recorded.asObservable();
  }

  getRecordedTime(): Observable<string> {
    return this._recordingTime.asObservable();
  }

  recordingFailed(): Observable<string> {
    return this._recordingFailed.asObservable();
  }

  openVoiceRecordModal(voiceRecordModal: TemplateRef<any>) {
    $('#voiceRecordModal').modal({
      backdrop: 'static',
      keyboard: false,
      class: 'modal-dialog-centered',
    });
    this.startRecording();
  }

  startRecording() {

    // if (this.recorder) {
    //   // It means recording is already started or it is already recording something
    //   return;
    // }

    this._recordingTime.next('00:00');
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      this.isRecording = true;
      navigator.mediaDevices.getUserMedia({ audio: true }).then(s => {
        this.stream = s;
        this.record();
      }).catch(error => {
        this.isRecording = false;
        this.noMediDeviceFound = 'No Microphones found. Sound recording is unavailable';
        this._recordingFailed.next();
      });
    } else {
      this.isRecording = false;
      this.noMediDeviceFound = 'No Microphones found. Sound recording is unavailable';
    }
  }

  record() {

    this.recorder = new RecordRTC.StereoAudioRecorder(this.stream, {
      type: 'audio',
      mimeType: 'audio/webm'
    });

    this.recorder.record();
    this.startTime = moment();
    this.interval = setInterval(
      () => {
        const currentTime = moment();
        const diffTime = moment.duration(currentTime.diff(this.startTime));
        const time = this.toString(diffTime.minutes()) + ':' + this.toString(diffTime.seconds());
        this.recordedTime = time;
        this._recordingTime.next(time);
      },
      1000
    );
  }

  stopRecording() {
    if (this.recorder) {
      this.recorder.stop((blob) => {
        if (this.startTime) {
          const mp3Name = encodeURIComponent('audio_' + new Date().getTime() + '.mp3');
          this.stopMedia();
          this._recorded.next({ blob: blob, title: mp3Name });
        }
      }, () => {
        this.stopMedia();
        this._recordingFailed.next();
      });
    }
  }

  abortRecording() {
    this.stopMedia();
  }

  toString(value) {
    let val = value;
    if (!value) {
      val = '00';
    }
    if (value < 10) {
      val = '0' + value;
    }
    return val;
  }

  stopMedia() {
    if (this.recorder) {
      this.recorder = null;
      this.isRecording = false;
      clearInterval(this.interval);
      this.startTime = null;
      if (this.stream) {
        this.stream.getAudioTracks().forEach(track => track.stop());
        this.stream = null;
      }
    }
  }

  clearRecordedData() {
    this.blobUrl = null;
    this.isRecording = false;
    $('#voiceRecordModal').modal('hide');
  }
  closeVoiceRecordModal() {
    this.blobUrl = null;
    this.isRecording = false;
    this.noMediDeviceFound = undefined;
    this.disableUploadButton = false;
    $('#voiceRecordModal').modal('hide');
    this.stopRecording();
  }
  uploadVoiceClip() {
    this.disableUploadButton = true;
    let file = this.blobForVoiceClip;
    if (!file) {
      setTimeout(() => {
      }, 2000);
    }
    else if (file && (file.type != 'image/jpg')) {
      this.uploadService.uploadfile(file).then((url) => {
        console.log('url in select file', url)
        this.urlOfUploadeVoice = url.Location
        const str = url.Key
        const res = str.split("/");
        const file_name = res[res.length - 1];
        setTimeout(() => {
          let data = {
            incident_type: '2',
            voice_file: [file_name]
          }
          this.fileComplainService.saveComplain(data).then(() => {
            this.closeVoiceRecordModal();
            this.toastr.success('Your case was submitted successfully!');
            this.router.navigate(['/my-complains']);
          }).catch((error) => {
            console.log('saveComplain_failure', error)
            this.disableUploadButton = false;
            this.toastr.error(error.error.message);
          });
        }, 1000);
      }).catch((error) => {
        console.log('voice_uploadfile_ failure', error)
        this.disableUploadButton = false;
        this.toastr.error(error.error.message);
      })
    } else {
      this.toastr.error('Only audio/wav and mp3 files are allowed');
      setTimeout(() => {
      }, 2000);
    }
  }

}
